import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { selectSpaceInfo } from '../../selectors/ContentSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { SiteTasksSpace, SiteTasksSpaceDispatchProps, SiteTasksSpaceStateProps } from './SiteTasksSpace';

const mapStateToProps: MapStateToProps<SiteTasksSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentCounts: selectContentCounts<'sitetasks'>(state, 'sitetasks'),
  contentCountsUpToDate: selectContentCountsUpToDate(state)
});

const mapDispatchToProps: MapDispatchToProps<SiteTasksSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedSiteTasksSpace = connect(mapStateToProps, mapDispatchToProps)(SiteTasksSpace);
